module.exports = __webpack_public_path__ + "img/base_divers_voiture.6705edef.svg";